import React, { useEffect, useRef, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { eye_icon } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { post, get } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const AddAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    whatsappmobile: "",
    role_id: "",
    name: "",
    password: "",
    confirmPassword: "",
    admin_code: "",
    ip_address: false,
    is_otp_enabled: false,
  });

  const [errors, setErrors] = useState({});
  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);
  const [roles, setRoles] = useState([]);

  const type = location?.state?.type;

  const UserId = location?.state?.id;

  const page = location?.state?.page;

  console.log("page view", page);

  const pageRef = useRef(page);
  useEffect(() => {
    pageRef.current = page;
    getRoles();
  }, [page]);

  const getRoles = async () => {
    let res = await get(URLS.ROLE_LIST);
    console.log("roles res", res);
    if (res?.status === "success") {
      setRoles(res?.data ?? []);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (type === "view") return true;

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!formData.name.trim()) newErrors.name = "User Name is required";
    if (!formData.admin_code.trim())
      newErrors.admin_code = "Admin Id is required";
    if (!formData.email.trim() || !emailRegex.test(formData.email))
      newErrors.email = "Valid Email is required";
    if (!formData.mobile.trim() || formData.mobile.length !== 10)
      newErrors.mobile = "Enter 10-digit mobile number";
    if (
      !formData.whatsappmobile.trim() ||
      formData.whatsappmobile.length !== 10
    )
      newErrors.whatsappmobile = "Enter 10-digit What'sapp number";
    if (!formData.role_id) newErrors.role_id = "Select a role";

    const password = formData.password?.trim() || "";
    const confirmPassword = formData.confirmPassword?.trim() || "";
    if (type === "add") {
      if (!passwordRegex.test(password)) {
        newErrors.password =
          "Password must be at least 8 characters, include uppercase, lowercase, number, and special character";
      }
      if (!confirmPassword || confirmPassword !== password) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    } else {
      if (password || confirmPassword) {
        if (!passwordRegex.test(password)) {
          newErrors.password =
            "Password must be at least 8 characters, include uppercase, lowercase, number, and special character";
        }
        if (!confirmPassword || confirmPassword !== password) {
          newErrors.confirmPassword = "Passwords do not match";
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetch = async () => {
    try {
      const adminData = JSON.parse(localStorage.getItem("admin_details"));
      if (!adminData?.id) return;

      const res = await get(`${URLS.ADMINURL}${UserId}/`);

      setFormData({
        email: res?.email || "",
        mobile: res?.mobile || "",
        whatsappmobile: res?.whatsapp_no || "",
        role_id: res?.role_id?.toString() || "",
        name: res?.name || "",
        password: "",
        confirmPassword: "",
        admin_code: res?.admin_code || "",
        ip_address: res?.is_ip_restricted,
        is_otp_enabled: res?.is_otp_enabled,
      });
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (type === "view" || type === "edit") {
      fetch();
    }
  }, [type]);

  const handleSubmit = () => {
    console.log("validate()", validate());

    if (validate()) {
      let formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("username", formData.name);
      formdata.append("email", formData.email);
      formdata.append("mobile", formData.mobile);
      formdata.append("whatsapp_no", formData.whatsappmobile);
      formdata.append("role_id", formData.role_id);
      formdata.append("admin_code", formData.admin_code);
      formdata.append("status", true);
      formdata.append("is_ip_restricted", formData?.ip_address);
      formdata.append("is_otp_enabled", formData?.is_otp_enabled);
      if (formData.password) {
        formdata.append("password", formData.password);
      }

      if (type === "edit") {
        post(`${URLS.ADMINURL}${UserId}/`, formdata)
          .then((res) => {
            if (res?.status === "success") {
              toast.success(res?.message);
              setTimeout(() => {
                navigate("/admin", { state: { page: pageRef.current } });
              }, 1500);
            }
          })
          .catch((err) => console.log("err", err));
      } else {
        post(URLS.ADMINURL, formdata)
          .then((res) => {
            if (res?.status === "success") {
              toast.success(res?.message);
              setTimeout(() => {
                navigate("/admin", { state: { page: pageRef.current } });
              }, 1500);
            }
          })
          .catch((err) => console.log("err", err));
      }
    }
  };

  useEffect(() => {
    const updateWhatsapp = () => {
      roles
        .filter((ele) => ele?.name == "Super Admin")
        .map((ele) => {
          console.log("ADSKKSADA", ele?.id, formData);
          if (ele?.id == formData?.role_id) {
            setIsWhatsapp(true);
          } else {
            setIsWhatsapp(false);
            setFormData((pre) => ({
              ...pre,
              is_otp_enabled: false,
            }));
          }
        });
    };
    // if()
    //
    updateWhatsapp(formData.role_id);
  }, [formData.role_id, roles]);
  console.log("formData", formData, roles, isWhatsapp);

  return (
    <div className="">
      <Topbar
        header={
          type === "view"
            ? "Admin View"
            : type === "edit"
              ? "Admin Edit"
              : "Add Admin"
        }
        page={pageRef.current}
      />
      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <p className="f3 mb-1">User Name</p>
          <input
            className="input-box"
            name="name"
            value={formData?.name}
            onChange={handleChange}
            type="text"
            placeholder="User Name"
            disabled={type === "view"}
          />
          {errors.name && <p className="err">{errors.name}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 mb-1">Admin ID</p>
          <input
            name="admin_code"
            value={formData.admin_code}
            onChange={handleChange}
            className="input-box"
            type="text"
            placeholder="Enter here"
            disabled={type === "view"}
          />
          {errors.admin_code && <p className="err">{errors.admin_code}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 mb-1">Mobile Number</p>
          <input
            className="input-box"
            name="mobile"
            value={formData.mobile}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange({ target: { name: "mobile", value } });
              }
            }}
            type="text"
            inputMode="numeric"
            maxLength={10}
            placeholder="Number"
            disabled={type === "view"}
          />

          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>
        <div className="col-md-5">
          <div style={{ display: "flex", gap: 10 }}>
            <p className="f3 mb-1">WhatsApp Number (Same as Mobile Number)</p>
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  setFormData((prev) => ({
                    ...prev,
                    whatsappmobile: prev.mobile,
                  }));
                } else {
                  setFormData((prev) => ({ ...prev, whatsappmobile: "" }));
                }
              }}
              disabled={type === "view"}
            />
          </div>
          <input
            className="input-box"
            name="whatsappmobile"
            value={formData.whatsappmobile}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                handleChange({ target: { name: "whatsappmobile", value } });
              }
            }}
            type="text"
            inputMode="numeric"
            maxLength={10}
            placeholder="Number"
            disabled={type === "view"}
          />

          {errors.whatsappmobile && (
            <p className="err">{errors.whatsappmobile}</p>
          )}
        </div>

        <div className="col-md-5">
          <p className="f3 mb-1">Roles</p>
          <select
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            className="input-box"
            disabled={type === "view"}
          >
            <option value="">Select Role</option>
            {roles?.map((item, ind) => (
              <option value={item?.id}>{item?.name}</option>
            ))}
          </select>
          {errors.role_id && <p className="err">{errors.role_id}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 mb-1">Email</p>
          <input
            className="input-box"
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            placeholder="Email"
            disabled={type === "view" || type === "edit"}
          />
          {errors.email && <p className="err">{errors.email}</p>}
        </div>

        {type !== "view" && (
          <div className="col-md-5">
            <p className="f3">Password</p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="password"
                value={formData.password}
                onChange={handleChange}
                type={visible ? "text" : "password"}
                maxLength={20}
                placeholder="Password"
              />
              {!visible ? (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              ) : (
                <VisibilityIcon
                  onClick={() => setVisible(!visible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>
        )}

        {type !== "view" && (
          <div className="col-md-5">
            <p className="f3">Confirm Password</p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                type={confVisible ? "text" : "password"}
                maxLength={20}
                placeholder="Confirm Password"
              />
              {!confVisible ? (
                <img
                  src={eye_icon}
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              ) : (
                <VisibilityIcon
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.confirmPassword && (
              <p className="err">{errors.confirmPassword}</p>
            )}
          </div>
        )}

        {/* // )} */}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 29,
          marginTop: 30,
        }}
      >
        <div style={{ display: "flex", gap: 10 }}>
          <p className="f3">IP Address</p>
          <input
            type="checkbox"
            disabled={type === "view"}
            checked={formData?.ip_address ?? false}
            onChange={() =>
              setFormData((pre) => ({
                ...pre,
                ip_address: !pre.ip_address,
              }))
            }
          />
        </div>
        {/* {isWhatsapp && ( */}
        <div style={{ display: "flex", gap: 10 }}>
          <p className="f3">Whatsapp Message</p>
          <input
            type="checkbox"
            disabled={type === "view"}
            checked={formData?.is_otp_enabled ?? false}
            onChange={() =>
              setFormData((pre) => ({
                ...pre,
                is_otp_enabled: !pre.is_otp_enabled,
              }))
            }
          />
        </div>
      </div>
      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() =>
            navigate("/admin", { state: { page: pageRef.current } })
          }
          className="back-btn mt-3 "
        >
          Back
        </button>
        {type !== "view" && (
          <button onClick={handleSubmit} className="submit-btn mt-3 ">
            {type === "edit" ? "Update" : "Add"}
          </button>
        )}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default AddAdmin;
